import { Box, makeStyles, TextField } from '@material-ui/core';
import React, { FC, useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { editBgVideo } from 'src/store/modules/imageUpload';
import { RootState, useSelector } from 'src/store';

interface editBgImageProps {
  menuTitle: string;
  type: string;
}

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    height: '100px',
    outline: 'none',
    overflow: 'overlay',
    '&:focus': {
      border: 0,
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  },
  root: {
    padding: '1.5rem 1rem'
  },
  menuTitle: {
    marginBottom: '1.5rem',
    fontSize: '0.875rem',
    fontWeight: 600,
    fontFamily: 'Archivo',
    letterSpacing: '0.0175rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  boxWrapper: {
    padding: '0.5rem',
    border: '1px solid #d9d9d9'
  },
  videoContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
  },
  textFieldWrapper: {
    width: '100%',
    height: '100px',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    gap: '0.5rem',
    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400
  }
}));

const EditBgVideo: FC<editBgImageProps> = ({ menuTitle, type }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.menuTitle}>{menuTitle}</div>
      <Box className={classes.boxWrapper}>
        <BgVideo type={type} />
      </Box>
    </div>
  );
};

export default EditBgVideo;

export const BgVideo = ({ type }: any) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);
  const bgVideo = useSelector((state: RootState) => state.imageUpload.bgVideo);

  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(bgVideo?.[type]);
  }, [bgVideo]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (newValue.endsWith('\\') || newValue.endsWith('\n')) {
      return;
    }

    setUrl(newValue);
    dispatch(
      editBgVideo({
        ...bgVideo,
        [type]: newValue
      })
    );
  };
  return (
    <Box className={classes.videoContainer}>
      <div className={classes.textFieldWrapper}>
        <TextField
          inputRef={inputRef}
          id="imageInput"
          multiline
          value={url}
          onChange={handleChange}
          placeholder="Please embed Video URL"
          className={classes.input}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              input: classes.inputText
            },
            disableUnderline: true
          }}
        />
      </div>
    </Box>
  );
};
